{
  "dismiss": "Opusti"
}